<template>
  <section class="section" id="locker-deliveries-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <locker-deliveries-title
        :lockerDeliveriesQty="lockerDeliveriesReverse.length"
        :lockerBeingManaged="lockerBeingManaged"
        @update-locker="updateLocker"
        @get-locker-deliveries="getLockerDeliveries"
        @download-locker-deliveries-report="downloadLockerDeliveriesReport"
      />

      <h2
        v-if="lockerDeliveriesReverse.length === 0"
        class="subtitle has-text-centered"
      >
        {{ $t("lockerDelivery.noDeliveriesAtThisTime") }}
      </h2>

      <div v-else>
        <h2 class="subtitle has-text-centered">
          {{ lockerBeingManaged.lockerInfo.name }}
        </h2>

        <locker-deliveries-table
          :lockerDeliveries="lockerDeliveriesReverse"
          @open-locker-delivery-details="openLockerDeliveryDetails"
          :hasCourier="lockerBeingManaged.lockerInfo.hasCourier"
        />
      </div>
    </div>

    <b-modal :active.sync="isLockerDeliveryModalActive">
      <locker-delivery-modal
        :lockerDelivery="lockerDelivery"
        @get-locker-deliveries="getLockerDeliveries"
      />
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import lockerDeliveriesTitle from "./LockerDeliveriesTitle";
import lockerDeliveriesTable from "./LockerDeliveriesTable";
import lockerDeliveryModal from "./locker-delivery-modal/LockerDeliveryModal";

export default {
  mixins: [common, mask],

  components: {
    lockerDeliveriesTitle,
    lockerDeliveriesTable,
    lockerDeliveryModal
  },

  data() {
    return {
      isLoading: false,
      locker: undefined,
      lockerName: null,
      isLockerDeliveryModalActive: false,
      lockerDelivery: {}
    };
  },

  computed: {
    ...mapGetters([
      "lockerBeingManaged",
      "lockerDeliveriesReverse",
      "lockerDeliveriesFilter"
    ])
  },

  methods: {
    getLockerDeliveries() {
      this.isLoading = true;
      this.$store
        .dispatch("getLockerDeliveries", {
          lockerId: this.locker,
          filter: this.lockerDeliveriesFilter
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateLocker(locker) {
      this.locker = locker ? locker.split("|")[0] : "";
      this.lockerName = locker
        ? locker.split("|")[1]
        : this.$t("lockerDeliveries.allLockers");
    },

    openLockerDeliveryDetails(lockerDelivery) {
      this.lockerDelivery = lockerDelivery;
      this.isLockerDeliveryModalActive = true;
    },

    downloadLockerDeliveriesReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadLockerDeliveriesReport", {
          lockerId: this.locker,
          filter: this.lockerDeliveriesFilter,
          lockerName: this.lockerName
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.getLockerDeliveries();
  },

  created() {
    this.locker = this.lockerBeingManaged._id;
    this.lockerName = this.lockerBeingManaged.lockerInfo.name;
  }
};
</script>

<style scoped>
#locker-deliveries-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
